const API_URL = '/api';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

export const fetchTreasurySummary = async () => {
  const res = await fetch(`${API_URL}/treasury/summary`, { headers: getHeaders() });
  return res.json();
};

export const fetchTreasuryTransactions = async () => {
  const res = await fetch(`${API_URL}/treasury/transactions`, { headers: getHeaders() });
  return res.json();
};

export const addTreasuryTransaction = async (data) => {
  const res = await fetch(`${API_URL}/treasury/transactions`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return res.json();
};

export const fetchDebts = async () => {
  const res = await fetch(`${API_URL}/treasury/debts`, { headers: getHeaders() });
  return res.json();
};

export const addDebt = async (data) => {
  const res = await fetch(`${API_URL}/treasury/debts`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return res.json();
};

export const addDebtPayment = async (debtId, data) => {
  const res = await fetch(`${API_URL}/treasury/debts/${debtId}/payments`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return res.json();
};

export const updateTreasuryTransaction = async (id, data) => {
  const res = await fetch(`${API_URL}/treasury/transactions/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return res.json();
};

export const deleteTreasuryTransaction = async (id) => {
  const res = await fetch(`${API_URL}/treasury/transactions/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return res.json();
};

export const updateDebt = async (id, data) => {
  const res = await fetch(`${API_URL}/treasury/debts/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return res.json();
};

export const deleteDebt = async (id) => {
  const res = await fetch(`${API_URL}/treasury/debts/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return res.json();
};
